import {
  dadataToken
} from './const';
import {
  showMessage
} from './utils';
import {
  dialog
} from '../base';


export function initLocationSuggestions() {
  $(document).ready(function () {
    const $city = $('#cityForPostal');

    $city.suggestions({
      token: dadataToken,
      type: 'ADDRESS',
      hint: false,
      scrollOnFocus: false,
      bounds: 'city-settlement',
      onSelect: changePage,
      onSuggestionsFetch: removeNonCity
    });
  });
}

export function initAddressSuggestions() {

  $(document).ready(function () {
    const $city = $('.suggest-city');
    const $street = $('.suggest-street');
    const $house = $('.suggest-home');

    const suggestForm = document.querySelector('.js-suggest-form');

    if (suggestForm === null) {
      return;
    }

    let fiasIdElement = document.querySelector('.js-data-fias-id');
    let fiasId = fiasIdElement.value;

    let fiasTypeElement = document.querySelector('.js-data-fias-type');
    let fiasType = fiasTypeElement.value;

    const fiasData = {
      _id: null,
      _type: null,
      set id(newId) {
        this._id = newId;
        fiasIdElement.value = newId;
      },
      set type(newType) {
        this._type = newType;
        fiasTypeElement.value = newType;
      }
    };

    $city.suggestions({
      token: dadataToken,
      type: 'ADDRESS',
      hint: false,
      scrollOnFocus: false,
      bounds: 'city-settlement',
      onSelect: onSelectCity,
      onSuggestionsFetch: removeNonCity
    });

    $street.suggestions({
      token: dadataToken,
      type: 'ADDRESS',
      hint: false,
      bounds: 'street',
      onSelect: onSelectStreet
    });

    $house.suggestions({
      token: dadataToken,
      type: 'ADDRESS',
      hint: false,
      noSuggestionsHint: false,
      bounds: 'house',
      constraints: $street,
      onSelect: onSelectHouse
    });

    enforceCity(fiasType);

    function onSelectCity(suggestion) {
      enforceCity(suggestion);
      fiasData.id = suggestion.data.fias_id;

      if (suggestion.data.city !== null) {
        fiasData.type = 'city';
      } else if (suggestion.data.settlement !== null) {
        fiasData.type = 'settlement';
      } else {
        showMessage('Неизвестный тип населенного пункта');
        return;
      }
    }

    function onSelectStreet() {
      clearPostalCode();
    }

    function onSelectHouse(suggestion) {
      showPostalCode(suggestion.data.postal_code);
    }

    function clearPostalCode() {
      $('#zip').val('');
    }

    function showPostalCode(code) {
      $('#zip').val(code);
    }

    function enforceCity(typeCity) {
      var sgt = $street.suggestions();

      if (typeCity === 'settlement' && fiasId) {
        sgt.setOptions({
          constraints: {
            locations: {
              // eslint-disable-next-line camelcase
              settlement_fias_id: fiasId
            }
          },
          // eslint-disable-next-line camelcase
          restrict_value: true
        });
      } else if (typeCity === 'city' && fiasId) {
        sgt.setOptions({
          constraints: {
            locations: {
              // eslint-disable-next-line camelcase
              city_fias_id: fiasId
            }
          },
          // eslint-disable-next-line camelcase
          restrict_value: true
        });
      } else {
        sgt.setOptions({
          constraints: $city,
          // eslint-disable-next-line camelcase
          restrict_value: false
        });
      }
    }
  });
}

function changePage(suggestion) {
  let fias = suggestion.data.fias_id;
  let domain = window.location.origin;
  let url = `${domain}/index.php?module=geo&task=setData&fias_id=${fias}`;

  dialog.preload();
  document.location.href = url;
}

function removeNonCity(suggestions) {
  return suggestions.filter(function (suggestion) {
    return suggestion.data.fias_level !== '5' && suggestion.data.fias_level !== '65';
  });
}
